import * as DKFDS from 'dkfds';
import $ from 'jquery';
import { fdsReset, fdsShowFieldError } from '../modals';

export function openSaveContactModal(index, title, type) {
    const $modal = $('#addContactAddressBookModal');

    fdsReset($modal);
    new DKFDS.Modal($modal.get(0)).show();

    $('input[name="newContactTitle"]').val(title);
    $('input[name="newContactIndex"]').val(index);
    $('input[name="newContactType"]').val(type);
}

function validateAndSave($modal) {
    const $title = $("#newContactTitle");
    const title = $title.val().trim();
    if (title === "") {
        fdsShowFieldError($title, 'Du skal angive en titel.');
        return false;
    } else {
        $modal.closest('form').submit();
        return true;
    }
}

$(() => {
    const $modal = $('#addContactAddressBookModal');

    $('#saveContactBtn').on('click', () => validateAndSave($modal));

    $modal.get(0).addEventListener('fds.modal.hidden', () => fdsReset($modal));

    if (hasFieldError) {
        new DKFDS.Modal($modal.get(0)).show();
    }
});
